import React, { Component } from "react";
import Lightbox from "react-image-lightbox";
import Col from "react-bootstrap/Col";
import Image from "react-bootstrap/Image";
import "react-image-lightbox/style.css";
import { backendUrl } from "../index";

interface AttachmentLightboxProps {
  images?: { thumb: string; full: string }[];
  photoIndex: number;
  classes?: string;
  likey: string;
}

export default class AttachmentLightbox extends Component<AttachmentLightboxProps> {
  state: {
    images?: { thumb: string; full: string }[];
    origPhotoIndex: number;
    photoIndex: number;
    classes: string;
    isOpen: boolean;
  };

  constructor(props: AttachmentLightboxProps) {
    super(props);

    this.state = {
      images: props.images,
      photoIndex: props.photoIndex,
      origPhotoIndex: props.photoIndex,
      classes:
        props.classes ||
        "d-flex align-items-stretch p-1 col-6 col-md-4 col-lg-3 col-xl-2",
      isOpen: false,
    };
  }

  render() {
    const { photoIndex, isOpen, images, origPhotoIndex } = this.state;
    if (!images) {
      return "";
    }
    return (
      <>
        <div
          className="lightbox-link"
          onClick={() => this.setState({ isOpen: true })}
          style={{ minHeight: 224 }}
        >
          <span className="icon-zoom-in" />
          <Image
            className="img-fluid"
            src={backendUrl + images[origPhotoIndex].thumb}
          />
        </div>

        {isOpen && (
          <Lightbox
            key={`${this.props.likey}-lb-${origPhotoIndex}`}
            mainSrc={backendUrl + images[photoIndex].full}
            mainSrcThumbnail={backendUrl + images[photoIndex].thumb}
            nextSrc={
              photoIndex < images.length - 1
                ? backendUrl + images[(photoIndex + 1) % images.length].full
                : undefined
            }
            nextSrcThumbnail={
              photoIndex < images.length - 1
                ? backendUrl + images[(photoIndex + 1) % images.length].thumb
                : undefined
            }
            prevSrc={
              photoIndex > 0
                ? backendUrl +
                  images[(photoIndex + images.length - 1) % images.length].full
                : undefined
            }
            prevSrcThumbnail={
              photoIndex > 0
                ? backendUrl +
                  images[(photoIndex + images.length - 1) % images.length].thumb
                : undefined
            }
            onCloseRequest={() => this.setState({ isOpen: false })}
            onMovePrevRequest={() =>
              this.setState({
                photoIndex: (photoIndex + images.length - 1) % images.length,
              })
            }
            onMoveNextRequest={() =>
              this.setState({
                photoIndex: (photoIndex + 1) % images.length,
              })
            }
          />
        )}
      </>
    );
  }
}
